import {
  DefaultButton,
  InfoCard,
  MaskedInput2,
  RadioButton,
} from 'components/index'
import { Icon } from 'assets/index'
import { Theme } from 'styles/Themes'
import { useContext, useEffect, useRef, useState } from 'react'
import { UserContext } from 'context/userContext'
import useFetch from 'hooks/useFetch'
import { Form } from '@unform/web'
import { Container } from './style'
import { formatExtract } from '../Transferir/factory'
import TransactionTable from '../TransactionTable'

interface TransferProps {
  enterprise: {
    name?: string
    id?: string
  }
}

export default function Depositar(props: TransferProps) {
  const { data, setPage, setResumoDepo } = useContext(UserContext)
  const [depositValue, setDepositValue] = useState<number | null>(null)
  const [tableData, setTableData] = useState<Array<any>>([])
  const [loading, setLoading] = useState<boolean>(false)
  const formRef = useRef<HTMLFormElement | any>(null)
  const api = useFetch()

  const { enterprise } = props

  useEffect(() => {
    // ***********************************************
    // BUSCAR DADOS DA TABELA DE EXTRATO
    // ***********************************************
    api
      .fetch(
        'get',
        null,
        `/gestor/enterprise/${enterprise.id}/extract?type=CREDIT`
      )
      .then((res) => {
        console.log(res.data.data)
        setTableData(formatExtract(res.data.data))
      })
      .catch((err) => {
        console.log(err)
      })
    // ***********************************************
  }, [])

  const handleDeposit = async () => {
    console.log(data, depositValue)
    if (!depositValue || depositValue === 0) return
    setLoading(true)
    try {
      const response: any = await api.fetch(
        'get',
        null,
        `/gestor/deposit/${
          data?.account?.value === 'neoin' ? 'client' : 'enterprise'
        }?id=${data?.account?.value}&value=${depositValue}`
      )
      if (response.fail) throw new Error(response.errors.message)
      console.log(response.data.data)
      setResumoDepo({
        depositValue,
        encodedImage: response.data.data.encodedImage,
        payload: response.data.data.payload,
      })
      setPage(1)
      setLoading(false)
    } catch (err: any) {
      console.log('err', err)
      setLoading(false)
    }
  }

  return (
    <Container>
      <h1 className="depositar-title">
        Depositar no <span>{enterprise.name}</span>
      </h1>
      <Form
        className="depositar-form-container"
        ref={formRef}
        onSubmit={() => console.log('submit')}
      >
        <MaskedInput2
          dataTestId="deposit-value"
          type="money"
          handleChange={(e: any) => setDepositValue(Number(e))}
          placeholder="Valor do depósito"
          name="deposit"
          defaultValue={depositValue}
        />
        <DefaultButton
          data-testid="deposit-button"
          small
          disabled={!depositValue || depositValue < 0}
          onClick={() => handleDeposit()}
          $loading={loading}
        >
          Gerar chave PIX
        </DefaultButton>
      </Form>
      <div className="depositar-table-container">
        <span className="depositar-table-title">Depósitos</span>
        <TransactionTable data={tableData} />
      </div>
    </Container>
  )
}
